/**
 * Sonmol pricing — AJAX add-to-cart depuis les cartes pricing.
 * Catch le clic sur les CTAs avec data-sonmol-add-variant, ajoute en AJAX,
 * et ouvre le cart drawer rafraîchi.
 *
 * Si le drawer n'est pas dispo (cart_type différent de drawer) ou si
 * une erreur survient, fallback vers la navigation classique (page produit).
 */

(function () {
  'use strict';

  const SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];

  document.addEventListener('click', async function (event) {
    const cta = event.target.closest('.sonmol-pricing__cta[data-sonmol-add-variant]');
    if (!cta) return;

    const variantId = cta.dataset.sonmolAddVariant;
    if (!variantId) return; // fallback : laisse le href agir

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      // Pas de drawer dispo → on laisse la nav classique vers la page produit
      return;
    }

    event.preventDefault();
    if (cta.dataset.loading === '1') return;
    cta.dataset.loading = '1';

    const labelEl = cta.querySelector('.sonmol-pricing__cta-label');
    const originalLabel = labelEl ? labelEl.textContent : cta.textContent;
    if (labelEl) labelEl.textContent = 'Ajout au panier…';
    cta.setAttribute('aria-busy', 'true');

    try {
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const response = await fetch(`${addUrl}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: SECTION_IDS,
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.description || `HTTP ${response.status}`);
      }

      const data = await response.json();
      // Nettoyer la classe is-empty AVANT renderContents (sinon le CSS Dawn masque les items)
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      drawer.renderContents(data); // gère le re-render + l'ouverture du drawer

      if (labelEl) labelEl.textContent = originalLabel;
      cta.removeAttribute('aria-busy');
      cta.dataset.loading = '0';
    } catch (err) {
      console.error('Sonmol pricing add error:', err);
      // Fallback : nav vers la page produit comme avant
      if (labelEl) labelEl.textContent = originalLabel;
      cta.removeAttribute('aria-busy');
      cta.dataset.loading = '0';
      window.location.href = cta.getAttribute('href');
    }
  });
})();
